import { useTranslation } from 'react-i18next';
import { Text } from '@user-portal/wikr-components';

import * as S from '../styled';

import { SidebarLinkButtonProps } from '../types';

const SidebarLinkButton = ({ isActive, title, icon: Icon }: SidebarLinkButtonProps) => {
    const { t } = useTranslation();

    return (
        <S.NavButton $isActive={isActive} data-testid="sidebar-link-button">
            {Icon && <Icon color="text-secondary" />}
            <Text type="medium-text" color="text-main">
                {t(title)}
            </Text>
        </S.NavButton>
    );
};

export default SidebarLinkButton;
